import './index_mWeb.css';
import {
  View,
  Text,
  PlaceHolder,
  ErrorMessage,
  EmptyData,
  PaginationIndicator,
  FlatListAutoHeight
} from '../../../component';
import ContestDetailsPlayerRowMWeb from '../contest_details_player_row/index_mWeb';
import I18n from '../../../utilities/locale';
import { useEffect, useState } from 'react';
import Constants from '../../../constants';
import { getRouteObjByGame } from '../../../utilities/helper';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '../../../actions/app-actions-types';
import FlatList from 'flatlist-react';
import { useLink } from 'react-router-stack';
import React from 'react';
interface Props {
  contestId?: any;
  userId?: any;
  winningsPerPosition?: any;
  getContestLeaderboard?: any;
  getContestUserLeaderboard?: any;
  tabType?: any;
  fantasyMatchClick?: any;
  completed?: boolean;
  matchStatus?: any;
  matchItem?: any;
  entryFee?: any;
  matchVerifiedStatus?: any;
  bonusPercentage?: any;
  gameState?: any;
  matchId?: any;
  getPlayerList?: any;
  matchTeamLock?: boolean;
  gameName?: any;
  myTeamListLen?: any;
  isGadgetLeague?: boolean;
  description?: any;
  questionList?: any;
  currencyType?: any;
  gameType?: any;
}

const ContestLeaderboardMWeb = ({
  fantasyMatchClick,
  completed,
  matchStatus,
  matchItem,
  contestId,
  userId,

  entryFee,
  tabType,
  matchVerifiedStatus,
  bonusPercentage,
  gameState,
  matchId,
  matchTeamLock,
  gameType,
  myTeamListLen = 0,
  isGadgetLeague = false,
  description = '',
  questionList = [],
  winningsPerPosition = {}
}: Props) => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const [hasMoreItems] = useState(false);
  const [error] = useState(false);
  const [leaderboardResultArrived, setLeaderboardResultArrived] = useState(true);
  const [userLeaderboardResultArrived] = useState(true);
  const [userLeaderboard] = useState([]);
  const { leaderboard: fantasyCricketLeaderboard, playerList: fantasyCricketPlayerList } =
    useSelector((state: any) => state.fantasy_cricket);
  const { leaderboard: fantasyFootballLeaderboard, playerList: fantasyFootballPlayerList } =
    useSelector((state: any) => state.fantasy_football);
  const { leaderboard: fantasyYesOrNoLeaderBoard } = useSelector(
    (state: any) => state.fantasy_yes_no
  );

  const [leaderboard, setLeaderBoard] = useState([] as any);
  const [playerList, setPlayerList] = useState([] as any);

  const loadMoreItems = () => {
    if (!hasMoreItems) return;
  };

  const onPressRetry = async () => {
    setLeaderboardResultArrived(false);
  };

  useEffect(() => {
    if (gameType === Constants.GameType.FANTASY_CRICKET) {
      setLeaderBoard(fantasyCricketLeaderboard[matchItem._id]);
      setPlayerList(fantasyCricketPlayerList[matchItem._id]);
    }
    if (gameType === Constants.GameType.FANTASY_FOOTBALL) {
      setLeaderBoard(fantasyFootballLeaderboard[matchItem._id]);
      setPlayerList(fantasyFootballPlayerList[matchItem._id]);
    }
    if (gameType === Constants.GameType.FANTASY_YES_NO) {
      setLeaderBoard(fantasyYesOrNoLeaderBoard[matchItem._id]);
    }
  }, []);

  const renderWhenEmpty = () => {
    if (!userLeaderboardResultArrived || !leaderboardResultArrived)
      return <PlaceHolder.Leaderboard />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={I18n.t('NoTeamFound')} />;
  };
  const renderItem = (item: any, index: any) => {
    const wonAmount = Object.entries(winningsPerPosition).sort((a: any, b: any) => b[0] - a[0]);
    let winningAmount: any = 0;
    try {
      winningAmount = wonAmount[index][0];
    } catch (e) {
      winningAmount = 0;
    }
    return (
      <ContestDetailsPlayerRowMWeb
        onPress={onPressPlayersRow}
        item={item}
        key={item.id}
        userId={userId}
        completed={completed}
        matchStatus={matchStatus}
        onPressSwitchTeam={onPressSwitchTeam}
        tabType={tabType}
        matchVerifiedStatus={matchVerifiedStatus}
        index={index}
        gameState={gameState}
        contestTeamsLength={userLeaderboard.length}
        isGadgetLeague={isGadgetLeague}
        description={description}
        gameType={gameType}
        wonAmount={winningAmount}
        idx={index}
      />
    );
  };
  const isShowPoint = tabType === 'LIVE' || tabType === 'RESULT';
  const isShowPrize = tabType === 'RESULT' && matchVerifiedStatus;

  const onPressPlayersRow = (teamData: any) => {
    const {
      userId: otherId = '',
      totalTeamsCount = 1,
      teamNumber = 1,
      teamName = '',
      answers: answerList = [],
      score = 0
    } = teamData;
    if (completed || otherId === userId) {
      if (gameType === Constants.GameType.FANTASY_SUBSTITUTION)
        teamData = { ...teamData, _id: teamData.matchTeamId };
      navigate.push(getRouteObjByGame(gameType)['team_preview'], {
        teamData,
        matchId,
        teamName,
        totalTeamsCount,
        item: matchItem,
        fromCreateTeam: false,
        lineupsOut: false,
        matchAllPlayersList: playerList,
        completed,
        gameType,
        isLeaderboard: true,
        isPreview: matchTeamLock,
        teamNumber,
        isMyUser: otherId === userId,
        matchVerifiedStatus,
        questionList,
        answerList,
        score
      });
    } else if (gameType === Constants.GameType.FANTASY_YES_NO) {
      dispatch(showToast(I18n.t('msgForPreviewTeamBeforeDeadlineYN')));
    } else {
      dispatch(showToast(I18n.t('msgForPreviewTeamBeforeDeadline')));
    }
  };

  const onPressSwitchTeam = (myItem: { _id?: '' | undefined; matchTeamId?: '' | undefined }) => {
    const { _id: leaderBoardTeamId = '', matchTeamId: preSwitchTeamId = '' } = myItem;
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: true,
          contestId,
          entryFee,
          bonusPercentage,
          isTeamSwitch: true,
          leaderBoardTeamId,
          contestTeams: userLeaderboard,
          preSwitchTeamId
        }
      })
    );
    if (myTeamListLen > userLeaderboard.length) {
      navigate.push(getRouteObjByGame(gameType)['my_teams']);
    } else {
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    }
  };

  const leaderBoardHeaderColor = {
    color: '#fff',
    flex: isShowPoint ? 2 : 0
  };

  const leaderBoardRankColor = {
    color: '#fff'
  };

  const data = [...userLeaderboard, ...leaderboard];

  return (
    <View className={'contest-leaderboard-container_mWeb'}>
      <View className={'contest-leaderboard-header-wrapper_mWeb'}>
        {leaderboard.length > 0 && (
          <Text className={'contest-leaderboard-header_mWeb'} style={{ ...leaderBoardHeaderColor }}>
            {'All Teams'}
          </Text>
        )}
        {isShowPoint && (
          <Text
            className={'contest-leaderboard-rank_mWeb'}
            style={{ ...leaderBoardRankColor, flex: 1 }}>
            {'Rank'}
          </Text>
        )}
        {isShowPoint && (
          <Text
            className={'contest-leaderboard-rank_mWeb'}
            style={{ ...leaderBoardRankColor, flex: 1 }}>
            {'Points'}
          </Text>
        )}
        {isShowPrize && (
          <Text
            className={'contest-leaderboard-rank_mWeb'}
            style={{ ...leaderBoardRankColor, flex: 2 }}>
            {'Prize'}
          </Text>
        )}
      </View>
      <FlatListAutoHeight>
        <FlatList
          list={data}
          renderItem={renderItem}
          renderWhenEmpty={renderWhenEmpty}
          hasMoreItems={hasMoreItems}
          loadMoreItems={loadMoreItems}
          renderOnScroll
          paginationLoadingIndicator={<PaginationIndicator />}
        />
        {!leaderboardResultArrived && data.length > 0 && <PlaceHolder.Leaderboard />}
      </FlatListAutoHeight>
    </View>
  );
};
export default React.memo(ContestLeaderboardMWeb);
